import Vue from "vue"
import Router from "vue-router"
import NewArticle from "./views/NewArticle.vue"
import Login from "./views/Login.vue"
import Writers from "./views/Writers.vue"
import Editors from "./views/Editors.vue"
import Administrators from "./views/Administrators.vue"
import Articles from "./views/Articles.vue"
import Postscripts from "./views/Postscripts.vue"
import AnalyticsGroups from "./views/AnalyticsGroups.vue"
import Bookcover from "./views/Bookcover.vue"
import Categories from "./views/Categories.vue"
import Curators from "./views/Curators.vue"
import SubCategories from "./views/SubCategories.vue"
import EditArticle from "./views/EditArticle.vue"
import AppAffiliates from "./views/AppAffiliates.vue"
import AppAffiliateTemplates from "./views/AppAffiliateTemplates.vue"
import RecommendCollections from "./views/RecommendCollections.vue"
import SpecialFeatures from "./views/SpecialFeatures.vue"
import SponsoredLinks from "./views/SponsoredLinks.vue"
import InlineAdvertisements from "./views/InlineAdvertisements.vue"
import AdsTxt from "./views/AdsTxt.vue"
import store from "@/store"
import api from "../src/honcierge-api"

Vue.use(Router)

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: Articles,
    },
    {
      path: "/app_affiliates",
      component: AppAffiliates,
    },
    {
      path: "/app_affiliate_templates",
      component: AppAffiliateTemplates,
    },
    {
      path: "/articles",
      component: Articles,
    },
    {
      path: "/articles/:id/edit",
      component: EditArticle,
    },
    {
      path: "/articles/shelf_story/:id",
      redirect: "/articles/:id/edit",
    },
    {
      path: "/new_article",
      component: NewArticle,
    },
    {
      path: "/writers",
      component: Writers,
    },
    {
      path: "/editors",
      component: Editors,
    },
    {
      path: "/administrators",
      component: Administrators,
    },
    {
      path: "/categories",
      component: Categories,
    },
    {
      path: "/sub_categories",
      component: SubCategories,
    },
    {
      path: "/curators",
      component: Curators,
    },
    {
      path: "/login",
      component: Login,
      meta: { isPublic: true, layout: "login" },
    },
    {
      path: "/postscripts",
      component: Postscripts,
    },
    {
      path: "/analytices_groups",
      component: AnalyticsGroups,
    },
    {
      path: "/bookcover",
      component: Bookcover,
    },
    {
      path: "/inline_advertisements",
      component: InlineAdvertisements,
    },
    {
      path: "/special_features",
      component: SpecialFeatures,
    },
    {
      path: "/recommend_collections",
      component: RecommendCollections,
    },
    {
      path: "/sponsored_links",
      component: SponsoredLinks,
    },
    {
      path: "/ads_txt",
      component: AdsTxt,
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
    },
  ],
})

router.beforeEach((to, _from, next) => {
  if (to.path === "/new_article") {
    store.dispatch("article/initArticle")
  }

  if (to.matched.some((record) => record.meta.isPublic)) {
    next()
  } else {
    api
      .getAdminUserByAuthToken()
      .then((response) => {
        store.commit("adminUser/updateAdminUser", response.data.adminUser)
        next()
      })
      .catch(() => {
        store.dispatch("logout")
        next({
          path: "/login",
          query: { redirect: to.fullPath },
        })
      })
  }
})

export default router
